import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'

import {
  getFirstEditingProjectVersionTitle,
  getFirstEditingProjectTitle,
  getEditingProjectIds,
  getEditingProjectVersionIds,
} from '@SiteModules/Popup/selectors'

import {
  closeDashboardPopups,
} from '@SiteModules/Popup/actions'

import {
  updateProjectTitle,
} from '@SiteModules/Project/actions'

import {
  updateProjectVersionTitle,
} from '@SiteModules/ProjectVersion/actions'

import './RenameProjectPopup.scss'

interface RenameProjectPopupProps {
  readonly isForProjectVersions: boolean
}

const RenameProjectPopup: React.FC<RenameProjectPopupProps> = props => {
  const dispatch = useDispatch()

  const {
    isForProjectVersions,
  } = props

  const title = isForProjectVersions ? useSelector(getFirstEditingProjectVersionTitle) : useSelector(getFirstEditingProjectTitle)
  const editingIds = isForProjectVersions ? useSelector(getEditingProjectVersionIds) : useSelector(getEditingProjectIds)
  const [newTitle, setNewTitle] = useState(title)

  const changeNewTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewTitle((e.target as HTMLInputElement).value)
  }

  const handleRename = () => {
    if (isForProjectVersions) {
      dispatch(updateProjectVersionTitle({ projectVersionId: editingIds[0], updatedTitle: newTitle.trim()}))
    } else {
      dispatch(updateProjectTitle({ projectId: editingIds[0], updatedTitle: newTitle.trim()}))
    }

    handleClose()
  }

  const handleClose = () => {
    dispatch(closeDashboardPopups())
  }

  const titleIsChanged = newTitle.trim() !== title.trim()
  const titleIsUnchanged = !titleIsChanged

  const shouldDisableButton = !newTitle.trim() || titleIsUnchanged

  return (
    <Popup
      className="RenameProjectPopup"
      closePopup={handleClose}
      zIndex={200000}
    >
      <div className="RenameProjectPopup__caption">
        {`${props.isForProjectVersions ? 'Change the title' : 'Rename the project'}`}
      </div>
        <input
          type="text"
          value={newTitle}
          onChange={changeNewTitle}
          placeholder="New title"
          autoComplete="off"
        />
        <Button
          styleType="brand"
          size="large"
          caption="Rename"
          disabled={shouldDisableButton}
          onClick={handleRename}
        />
    </Popup>
  )
}

export default RenameProjectPopup
